import NPagination from './NPagination';
export { NPagination }
export default NPagination;